import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=c4304f94&"
import script from "./Travel.vue?vue&type=script&lang=ts&"
export * from "./Travel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports